<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import modalAddAttribute from "../../../components/modals/merchandise/modalAddAttribute.vue";
    import modalEditAttribute from "../../../components/modals/merchandise/modalEditAttribute.vue";
    import modalLinkAttributeToCategory from "../../../components/modals/merchandise/modalLinkAttributeToCategory.vue";
    import Swal from "sweetalert2";
    import Merchandising from "../../../services/Merchandising";

    export default {
        components: {
          Layout,
          PageHeader,
          modalAddAttribute,
          modalEditAttribute,
          modalLinkAttributeToCategory,
        },
        page: {
            title: "Attributes",
            meta: [
                {
                    name: "description",
                    content: appConfig.description,
                },
            ],
        },
         data() {
            return {
                selectedCompanyData:null,
                isAuthorized: false,
                error: null,
                filterData: false,
                showMapData: false,
                showMap: false,
                tableData: [],
                title: "Attributes",
                items: [
                    {
                        text: "Merchandising",

                    },
                    {
                        text: "Attributes",
                        active: true,
                    },
                ],
                ticketing_client_types:[],
                userStatuses: [],
                filterInput: {
                    name: '',
                    gender: [],
                    company_id: '',
                    userStatus: [],
                },
                companyData: [],
                countries: [],
                productCategories:[],
                id:'',
                name:'',
                description:'',
                visibility:'',
                type:'',
                order:'',
                isBusy: false,
                totalRows: 0,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 25, 50, 100],
                filter: null,
                filterOn: [],
                sortBy: "order",
                sortDesc: false,
                fields: [

                    {
                        key: "attr_id",
                        label: "Attribute ID",
                        sortable: true,
                    },
                    {
                      key: "name",
                      label: "Name",
                      sortable: true,
                    },
                    {
                        key: "description",
                        label: "Description",
                        sortable: true,
                    },
                    {
                      key:"categories",
                      label:"Linked Categories",
                      sortable:true
                    },
                    {
                      key:"terms",
                      label:"Terms",
                      sortable:true
                    },
                    {
                      key: "visibility",
                      label: "Visible",
                      sortable: true,
                    },
                    {
                        key: "type",
                        label: "Type",
                        sortable: true,
                    },
                    {
                        key: "order",
                        label: "Order",
                        sortable: true,
                    },
                    "action"
                ],
            };
        },

        methods: {
            openModalAddAttribute(){
                this.$bvModal.show("add_attribute");
            },
            openModalLinkAttribute(id,categories,name){
                this.id = id;
                this.productCategories = categories;
                this.name = name
                this.$bvModal.show("link_attribute");
            },
            openModalUpdateAttribute(id, name, description, visibility, type, order){
              this.id = id
              this.name = name
              this.description = description
              this.visibility = visibility
              this.type = type
              this.order = order
              this.$bvModal.show("update_attribute");
            },


          async getAttributes(){
                try {
                    this.filterData = true;
                    this.toggleBusy();

                    const response = await Merchandising.getAttributes()
                    this.tableData = response.data.data
                    this.totalRows = this.tableData.length
                } catch (error) {
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.tableData = []
                    this.totalRows = 0;
                } finally {
                    this.toggleBusy();
                }
            },



          async removeAttribute(attr_id) {
            Swal.fire({
              title: "Remove Attribute?",
              text: "This attribute will be deleted!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Delete!",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {

                        const response = await Merchandising.removeAttribute(attr_id);
                        if (response.data.data) {
                          Swal.fire("Success!", "Attribute is successfully deleted !", "success");
                          await  this.getAttributes();
                        } else {
                            let errorMessage = response.error ? response.error : 'Failed';
                            if (typeof errorMessage === 'object') {
                                errorMessage = errorMessage[0];
                            }
                            Swal.fire("Fail!", errorMessage, "warning");
                        }
                    } catch (error) {
                        let errorMessage = error.response && error.response.data && error.response.data.error
                            ? error.response.data.error
                            : "An error occurred while deleting attribute!";
                        if (typeof errorMessage === 'object') {
                          errorMessage = errorMessage[0];
                        }
                        Swal.fire("Error", errorMessage, "error");
                    }
                }
            });
          },

        },
        mounted() {
            this.getAttributes();
        },
        middleware: "authentication",
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items"/>
        <div class="row">
            <div class="col-12">

                <div class="card">
                    <div class="card-body">
                            <div>
                                <a href="javascript:void(0);" @click="openModalAddAttribute" class="btn btn-success waves-effect waves-light me-3">
                                    <i class="mdi mdi-plus me-2"></i>
                                    Add New Attribute
                                </a>
                            </div>
                        <div class="row mt-2">
                            <div class="col d-inline-flex align-items-center" >
                                <h4 class="card-title m-0">Total Attributes: {{totalRows}}</h4>
                            </div>
                        </div>


                        <div class="row mt-4" v-show="filterData">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select
                                            v-model="perPage"
                                            size="sm"
                                            :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div
                                    id="tickets-table_filter"
                                    class="dataTables_filter text-md-end"
                                >
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                            v-model="filter"
                                            type="search"
                                            placeholder="Search..."
                                            class="form-control form-control-sm ms-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0" v-show="filterData">
                            <b-table
                                :items="tableData"
                                :busy="isBusy"
                                :fields="fields"
                                responsive="sm"
                                :per-page="perPage"
                                :current-page="currentPage"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :filter="filter"
                                :filter-included-fields="filterOn"
                                show-empty
                                empty-text="No Data Found"
                            >
                               

                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>
                                <template  v-slot:cell(visibility)="data">
                                  <span>{{data.item.visibility === 1 ? 'Yes' : 'No'}}</span>
                                </template>


                                <template  v-slot:cell(terms)="data">
                                  <span>{{ Object.keys(data.item.terms).length }}</span>
                                </template>

                              <template  v-slot:cell(categories)="data">
                                <span>{{ Object.keys(data.item.categories).length }}</span>
                              </template>
                                <template v-slot:cell(action)="data">
                                    <ul class="list-inline mb-0 ">
                                        <li class="list-inline-item">
                                            <a href="javascript:void(0)" @click="openModalLinkAttribute(data.item.attr_id,data.item.categories,data.item.name)" title="Link Attribute to Category">
                                              <i class="uil uil-link px-2 font-size-18"></i>
                                            </a>
                                        </li>
                                        <li v-if="data.item.categories.length > 0" class="list-inline-item">
                                          <router-link :to="{
                                            path: `/merchandising/manage_attribute_term/${data.item.attr_id}`
                                          }"  title="Manage Attribute Terms">
                                            <i class="dripicons-gear font-size-14"></i>
                                          </router-link>
                                        </li>
                                        <li class="list-inline-item">
                                          <a  href="javascript:void(0);" class="px-2 text-black" title="Edit Attribute" @click="
                                          openModalUpdateAttribute(data.item.attr_id,data.item.name,data.item.description,data.item.visibility,data.item.type,data.item.order)
                                          ">
                                            <i class="fas fa-pen font-size-14 text-primary" ></i>
                                          </a>
                                      </li>
                                      <li class="list-inline-item">
                                        <a  href="javascript:void(0);" class="px-2 text-black" title="Remove Attribute" @click="removeAttribute(data.item.attr_id)">
                                          <i class="uil uil-trash-alt font-size-18 text-danger" ></i>
                                        </a>
                                      </li>
                                    </ul>
                                </template>
                            </b-table>
                        </div>
                        <div class="row" v-show="filterData">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination
                                            v-model="currentPage"
                                            :total-rows="totalRows"
                                            :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

  <modalAddAttribute @onRefresh="getAttributes"></modalAddAttribute>
  <modalEditAttribute @onRefresh="getAttributes" :id="this.id" :name="this.name" :description="this.description" :visibility="this.visibility" :order="this.order" :type="this.type"></modalEditAttribute>
  <modalLinkAttributeToCategory @onRefresh="getAttributes" :id="this.id" :categories="this.productCategories" :name="this.name"></modalLinkAttributeToCategory>
    </Layout>
</template>
<style>

</style>